import e from "react";
import { View as t } from "../../../primitives/View/View.js";
import { useAuthenticator as a } from "@aws-amplify/ui-react-core";
import { useCustomComponents as r } from "../hooks/useCustomComponents/index.js";
var o = function o(e) {
  return "signIn" === e || "signUp";
};
function n(_ref) {
  var n = _ref.children,
    i = _ref.className,
    _ref$variation = _ref.variation,
    m = _ref$variation === void 0 ? "default" : _ref$variation;
  var _a = a(function (_ref2) {
      var e = _ref2.route;
      return [e];
    }),
    c = _a.route,
    _r = r(),
    _r$components = _r.components,
    l = _r$components.Header,
    s = _r$components.Footer;
  return e.createElement(t, {
    className: i,
    "data-amplify-authenticator": "",
    "data-variation": m
  }, e.createElement(t, {
    "data-amplify-container": ""
  }, e.createElement(l, null), e.createElement(t, {
    "data-amplify-router": "",
    "data-amplify-router-content": o(c) ? void 0 : ""
  }, n), e.createElement(s, null)));
}
export { n as RouteContainer };